import { api } from './client';

export interface OrgTgStatus {
  organization_id: string;
  chat: { chat_id: string; linked_at: string } | null;
  pending: { code: string; expires_at: string } | null;
  bot_username: string;
}

export interface TgCodeOut {
  code: string;
  expires_at: string;
  bot_username: string;
}

export const orgTgApi = {
  status: (orgId: string) =>
    api.get<OrgTgStatus>(`/api/v1/tg/${orgId}`).then(r => r.data),
  link: (orgId: string) =>
    api.post<TgCodeOut>(`/api/v1/tg/${orgId}/link-code`).then(r => r.data),
  unlink: (orgId: string) =>
    api.delete(`/api/v1/tg/${orgId}`),
};
